import { IController, IScope, IWindowService } from 'angular';
import { IStateService } from 'angular-ui-router';
import * as _ from 'lodash';
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { StudentListPreviewModal } from '../../../../shared/modals/student-list-preview/student-list-preview.service';
import { ISdcStore } from '../../../flux/sdc-store.interface';
import { SdcStateService } from '../../../sdc-state/sdc-state.service';
import { IWizardFilterActionsOptions } from './../../components/wizard-filter-actions/wizard-filter-actions.typings';

export class WizardFilterActionsCtrl implements IController {
  static inject: string[] = [
    '$scope',
    '$state',
    '$window',
    'SDCStore',
    'ObjectCache',
    'UtilitiesService',
    'StudentListPreviewModal',
    'SdcStateService',
  ];

  public uiReady: boolean = false;
  public additionalActions;

  public filterActions;

  constructor(
    private $scope: IScope,
    private $state: IStateService,
    private $window: IWindowService,
    private SDCStore: ISdcStore,
    private ObjectCache,
    private UtilitiesService: UtilitiesService,
    private StudentListPreviewModal: StudentListPreviewModal,
    private SdcStateService: SdcStateService,
  ) {}

  $onInit(): void {
    this.filterActions = Object.assign({}, this.filterDefaultActions, this.additionalActions);
  }

  private getCurrentSdc() {
    const state = this.SDCStore.getUiState().currentActivity.state;
    const sdcKey = this.SDCStore.getSdcKeyFromUiState();
    const sdcActivity = this.SdcStateService.determineSdcActivityFromState(state);
    return {
      sdcKey,
      sdcActivity,
    };
  }

  // Checks whether cols requested are valid for this SDC.
  private columnsAreValid(cols): boolean {
    const validCols = [];
    const activity = this.getCurrentSdc().sdcActivity;
    _.each(cols, col => {
      const columnFound = _.includes(activity.columns, col);
      if (columnFound) validCols.push(col);
    });
    return validCols.length === cols.length;
  }

  private setFilter(ids): string {
    return this.ObjectCache.cacheObject({ studentId: ids });
  }

  // determine what will be cached
  private setSort(sortObj): string {
    let colId;
    let sort;
    const cols = sortObj && sortObj.colId ? [sortObj.colId] : []; // col validation expects an array.
    const isValid = this.columnsAreValid(cols);
    if (isValid) {
      colId = sortObj.colId;
      sort = sortObj.sort;
    } else {
      colId = null;
      sort = `desc`;
      console.warn(`Column [${sortObj.colId}] is not valid for this SDC. Default sort will be applied.`);
    }

    return this.ObjectCache.cacheObject({ colId, sort });
  }

  private filterDefaultActions = {
    openPreviewModal: {
      open: (studentIds: string[], options: IWizardFilterActionsOptions): void => {
        const filter = { studentId: studentIds };
        const isValid = this.columnsAreValid(options.columnKeys);
        let cols;
        // modal will still open but display default cols, warning logged
        if (isValid) {
          cols = options.columnKeys;
        } else {
          console.warn(`Cols [${options.columnKeys}] are not valid for this SDC. Default columns will be displayed.`);
          cols = [];
        }
        this.StudentListPreviewModal.openPreview(filter, cols, null);
      },
      label: 'Preview students',
    },
    openGrid: {
      open: (studentIds: string[], options: IWizardFilterActionsOptions): void => {
        const filter = this.setFilter(studentIds);
        let sort;
        if (options.sort) {
          sort = this.setSort(options.sort); // calls validation internally and sets cache based on validation
        }
        const route = `main.school.new-sdc.${this.getCurrentSdc().sdcKey}.grid`;
        this.$state.go(route, { filter, sort });
      },
      label: 'View in grid',
    },
    openSsv: {
      open: (studentIds: string[], options: IWizardFilterActionsOptions): void => {
        const filter = this.setFilter(studentIds);
        let sort;
        if (options.sort) {
          sort = this.setSort(options.sort); // calls validation internally and sets cache based on validation
        }
        const route = `main.school.new-sdc.${this.getCurrentSdc().sdcKey}.profile`;
        // TODO: return sort SSV transition - JE
        this.$state.go(route, { filter });
      },
      label: 'View profiles',
    },
  };
}
